<template>
  <img src="/images/diver-logo-white.png" alt="STAGE DIVER" />
</template>
